import { ItineraryDayTimespan } from '~/models/ItineraryDayTimespan'
import { BaseMemoryCache } from '~/passporter-services/baseMemoryCache'

class ItineraryDayTimespansCache extends BaseMemoryCache<ItineraryDayTimespan> {
	private buildKey(itineraryId: string, dayNumber: number): string {
		return `${itineraryId}-day-${dayNumber}`
	}

	getDayTimespans(itineraryId: string, dayNumber: number): ItineraryDayTimespan[] | undefined {
		const cached = this.get(this.buildKey(itineraryId, dayNumber))
		if (!Array.isArray(cached)) return
		return cached as ItineraryDayTimespan[]
	}

	setDayTimespans(itineraryId: string, dayNumber: number, timespans: ItineraryDayTimespan[]): void {
		this.set(timespans, this.buildKey(itineraryId, dayNumber))
	}

	invalidateDay(itineraryId: string, dayNumber: number): void {
		this.delete(this.buildKey(itineraryId, dayNumber))
	}

	invalidateItinerary(itineraryId: string): void {
		this.deleteManyThatStartWith(`${itineraryId}-day-`)
	}
}

export const itineraryDayTimespansCache = new ItineraryDayTimespansCache()
